import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useShowMoreButton } from '../../../hooks/useShowMoreButton';
import useToggle from '../../../hooks/useToggle';
import { ReadMoreButton, ReadMoreWrapper } from './styled';

interface ReadMoreProps {
  description: string | ReactNode;
}

export const ReadMore: React.FC<ReadMoreProps> = ({ description }) => {
  const { t } = useTranslation();
  const [visibleText, showText] = useToggle(false);
  const [targetRef, showButton] = useShowMoreButton();

  return (
    <>
      <ReadMoreWrapper
        tag="p"
        $isPruned={!visibleText}
        ref={targetRef}
        id="read-more"
        data-cy="read-more"
      >
        {description}
      </ReadMoreWrapper>
      {showButton && !visibleText && (
        <ReadMoreButton
          tag="body_1"
          onClick={showText}
          onKeyPress={() => {}}
          tabIndex={0}
          role="button"
        >
          {t('common.read_more')}
        </ReadMoreButton>
      )}
    </>
  );
};
